export default __webpack_public_path__ + "static/media/Trackertools-screenshot-mobile.edf8665e.png";